import {atomWithDefault} from 'jotai/utils';
import {getFunctionList} from './service';

//服务列表
export const serviceListAtom = atomWithDefault(async () => {
    return await getFunctionList();
});
